<template>
  <div class="rightChart">
    <div class="radio">
      <el-radio v-model="iore" label="出口" @change="changeIore">出口（百万美元）</el-radio>
      <el-radio v-model="iore" label="进口" @change="changeIore">进口（百万美元）</el-radio>
    </div>
    <div class="bottomLeft">
      <!-- 标题 -->
      <div class="mapTitle">
        <div class="littleImg">
          <img src="../assets/img/littleImg.png" alt />
        </div>
        <div class="word">分省{{iore}}金额及排名情况</div>
      </div>
      <!-- 地图 -->
      <div id="map"></div>
    </div>
    <div class="bottomRight">
      <!-- 标题 -->
      <div class="cakeTitle">
        <div class="littleImg">
          <img src="../assets/img/littleImg.png" alt />
        </div>
        <div class="word">{{iore}}金额按海关口岸分布</div>
      </div>
      <!-- 饼图 -->
      <div id="tree"></div>
    </div>
    <div class="bottomLeft">
      <!-- 标题 -->
      <div class="mapTitle">
        <div class="littleImg">
          <img src="../assets/img/littleImg.png" alt />
        </div>
        <div class="word">主要{{iore}}贸易伙伴</div>
      </div>
      <!-- 树图-->
      <div id="word"></div>
    </div>
    <div class="bottomRight">
      <!-- 标题 -->
      <div class="cakeTitle">
        <div class="littleImg">
          <img src="../assets/img/littleImg.png" alt />
        </div>
        <div class="word">按贸易方式分{{iore}}分布情况</div>
      </div>
      <!-- 柱图 -->
      <div id="graph"></div>
    </div>
    <div class="bottom_timeLine">
      <div id="timeLine"></div>
      <!-- <img src="../assets/img/play.png" v-if="false" alt />
      <img src="../assets/img/stop.png" alt />
      <img src="../assets/img/left.png" class="img" alt />
      <div class="thinBox">
        <div class="thin">
          <p v-for="(v,i) in moveYearsList" :key="i"></p>
        </div>
        <div class="thins">
          <p v-for="(v,i) in moveYearsList" :key="i">{{v}}</p>
        </div>
      </div>
      <img src="../assets/img/right.png" class="img" alt />-->
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import echarts from "echarts";
import "../../node_modules/echarts/map/js/world.js";
import chinaJson from '../../static/common/china.json';
export default {
  data() {
    return {
      iore: "出口",
      timeLine: null,
      Datas: [],
      moveYearsList: []
    };
  },
  props: ["initEchart"],
  watch: {
    initEchart() {
      this.changeIore();
      this.timeLine.resize();
    }
  },
  methods: {
    // 中国地图
    map(year, iore) {
      var mapList = [];
      var yData = [];
      var max = 1,
        min = 1;
      var myMap = echarts.init(document.getElementById("map"));
      myMap.resize();
      api.getPicDataByNames("region", year, iore).then(res => {
        res.data.DATA.forEach(item => {
          var newArr = {};
          newArr.name = item.name;
          newArr.value = item.value;
          mapList.push(newArr);
        });
        for (var i = 0; i < mapList.length; i++) {
          yData.push(mapList[i].name);
        }
        if (this.timeLine == null) {
          if (this.moveYearsList != []) {
            this.time(this.moveYearsList); //时间轴
          }
        }
        if (mapList.length > 0) {
          var arr = [];
          mapList.forEach((v, i) => {
            arr.push(v.value);
          });
          max = Math.max(...arr);
          min = Math.min(...arr);
        }
        var optionMap = {
          tooltip: {
            //鼠标移上去时显示悬浮框
            trigger: "item",
            // backgroundColor: "transparent", //悬浮框最外层设置了默认padding;5,背景色灰色，如果要自定义，设置padding:0;或者背景色透明。
            // padding: 0,
            formatter: "{b}\n{c}"
          },
          visualMap: {
            type: "continuous",
            itemWidth: 10,
            itemHeight: 80,
            text: ["高", "低"],
            showLabel: true,
            seriesIndex: [0],
            min: min,
            max: max,
            inRange: {
              color: ["#87cefa", "#dfed27", "#e6521b"]
            },
            textStyle: {
              color: "#7B93A7"
            },
            bottom: 30,
            left: "left"
          },
          grid: {
            right: 10,
            top: 40,
            bottom: 30,
            width: "25%"
          },
          xAxis: {
            show: false
          },
          yAxis: {
            type: "category",
            inverse: true,
            nameGap: 16,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              margin: 45,
              textStyle: {
                color: "#DFECF7",
                align: "left",
                fontSize: 14
              }
            },
            data: yData.slice(0, 10)
          },
          geo: {
            // roam: true,
            map: "china",
            left: "left",
            right: "300",
            top: "20",
            //   layoutSize: '80%',
            label: {
              normal: {
                show: true ////省份名称
              }
            },
            itemStyle: {
              emphasis: {
                areaColor: "#fff464"
              }
            }
          },
          series: [
            {
              name: "mapSer",
              type: "map",
              roam: false,
              geoIndex: 0,
              data: mapList
            },
            {
              name: "barSer",
              type: "bar",
              roam: false,
              visualMap: false,
              zlevel: 2,
              barMaxWidth: 8,
              barGap: 0,
              itemStyle: {
                normal: {
                  color: function(params) {
                    // build a color map as your need.
                    var colorList = [
                      {
                        colorStops: [
                          {
                            offset: 0,
                            color: "#0664BE" // 0% 处的颜色
                          },
                          {
                            offset: 1,
                            color: "#1C83E8" // 100% 处的颜色
                          }
                        ]
                      },
                      {
                        colorStops: [
                          {
                            offset: 0,
                            color: "#0664BE" // 0% 处的颜色
                          },
                          {
                            offset: 1,
                            color: "#1C83E8" // 100% 处的颜色
                          }
                        ]
                      }
                    ];
                    if (params.dataIndex < 3) {
                      return colorList[0];
                    } else {
                      return colorList[1];
                    }
                  },
                  barBorderRadius: 15
                }
              },
              data: mapList.slice(0, 10)
            }
          ]
        };
        if (optionMap && typeof optionMap === "object") {
          myMap.clear();
          echarts.registerMap("china",chinaJson);
          myMap.setOption(optionMap);
          window.onresize = myMap.resize;
        }
      });
    },
    tree(year, iore) {
      var myTree = echarts.init(document.getElementById("tree"));
      myTree.resize();
      api.getPicDataByNames("port", year, iore).then(res => {
        var data = res.data.DATA;
        for (var n in data) {
          data[n]["name"] = data[n]["name"] + " " + data[n]["value"];
        }

        var option = {
          visualMap: {
            show: false,
            min: 0,
            max: 70,

            textStyle: {
              color: "#333",
              fontSize: 14,
              align: "right"
            },
            inRange: {
              color: [
                "#3B8CDB",
                "#8EC2F5",
                "#035CB2",
                "#0365C4",
                "#0D6CC9",
                "#2782DB",
                "#1B79D5"
              ] //
            }
          },
          // backgroundColor: "#000",
          tooltip: {
            trigger: "item",
            formatter: "{b}"
          },
          series: [
            {
              type: "treemap",
              width: "100%",
              height: "90%",
              roam: false, //是否开启拖拽漫游（移动和缩放）
              // nodeClick: true, //点击节点后的行为,false无反应
              breadcrumb: {
                show: false
              },
              label: {
                //描述了每个矩形中，文本标签的样式。
                normal: {
                  show: true,
                  position: ["10%", "40%"]
                }
              },
              itemStyle: {
                normal: {
                  show: true,
                  textStyle: {
                    color: "#fff",
                    fontSize: 14
                  },
                  borderWidth: 1,
                  borderColor: "transparent"
                },

                emphasis: {
                  label: {
                    show: true
                  }
                }
              },
              data: data
            }
          ]
        };
        myTree.setOption(option);
      });
    },
    graph(year, iore) {
      var xAxis_data = [];
      var series_data = [];
      var myGraph = echarts.init(document.getElementById("graph"));
      myGraph.resize();
      api.getPicDataByNames("transport", year, iore).then(res => {
        let _data = res.data.DATA;
        _data.forEach((v, i) => {
          xAxis_data.push(v.name);
          series_data.push(v.value);
        });
        var option = {
          color: ["#1C83E8"],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: [
            {
              type: "category",
              data: xAxis_data,
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                textStyle: {
                  color: "#fff"
                }
              }
            }
          ],
          yAxis: [
            {
              type: "value",
              axisLabel: {
                textStyle: {
                  color: "#fff"
                }
              }
            }
          ],
          series: [
            {
              type: "bar",
              barWidth: "17px",
              data: series_data,
              itemStyle: {}
            }
          ]
        };
        myGraph.setOption(option);
      });
    },
    //世界图
    word(year, iore) {
      var words = echarts.init(document.getElementById("word"));
      let nameMap = {
        Afghanistan: "阿富汗",
        Singapore: "新加坡",
        Angola: "安哥拉",
        Albania: "阿尔巴尼亚",
        "United Arab Emirates": "阿联酋",
        Argentina: "阿根廷",
        Armenia: "亚美尼亚",
        "French Southern and Antarctic Lands": "法属南半球和南极领地",
        Australia: "澳大利亚",
        Austria: "奥地利",
        Azerbaijan: "阿塞拜疆",
        Burundi: "布隆迪",
        Belgium: "比利时",
        Benin: "贝宁",
        "Burkina Faso": "布基纳法索",
        Bangladesh: "孟加拉国",
        Bulgaria: "保加利亚",
        "The Bahamas": "巴哈马",
        "Bosnia and Herzegovina": "波斯尼亚和黑塞哥维那",
        Belarus: "白俄罗斯",
        Belize: "伯利兹",
        Bermuda: "百慕大",
        Bolivia: "玻利维亚",
        Brazil: "巴西",
        Brunei: "文莱",
        Bhutan: "不丹",
        Botswana: "博茨瓦纳",
        "Central African Republic": "中非共和国",
        Canada: "加拿大",
        Switzerland: "瑞士",
        Chile: "智利",
        China: "中国",
        "Ivory Coast": "象牙海岸",
        Cameroon: "喀麦隆",
        "Democratic Republic of the Congo": "刚果民主共和国",
        "Republic of the Congo": "刚果共和国",
        Colombia: "哥伦比亚",
        "Costa Rica": "哥斯达黎加",
        Cuba: "古巴",
        "Northern Cyprus": "北塞浦路斯",
        Cyprus: "塞浦路斯",
        "Czech Republic": "捷克共和国",
        Germany: "德国",
        Djibouti: "吉布提",
        Denmark: "丹麦",
        "Dominican Republic": "多明尼加共和国",
        Algeria: "阿尔及利亚",
        Ecuador: "厄瓜多尔",
        Egypt: "埃及",
        Eritrea: "厄立特里亚",
        Spain: "西班牙",
        Estonia: "爱沙尼亚",
        Ethiopia: "埃塞俄比亚",
        Finland: "芬兰",
        Fiji: "斐",
        "Falkland Islands": "福克兰群岛",
        France: "法国",
        Gabon: "加蓬",
        "United Kingdom": "英国",
        Georgia: "格鲁吉亚",
        Ghana: "加纳",
        Guinea: "几内亚",
        Gambia: "冈比亚",
        "Guinea Bissau": "几内亚比绍",
        Greece: "希腊",
        Greenland: "格陵兰",
        Guatemala: "危地马拉",
        "French Guiana": "法属圭亚那",
        Guyana: "圭亚那",
        Honduras: "洪都拉斯",
        Croatia: "克罗地亚",
        Haiti: "海地",
        Hungary: "匈牙利",
        Indonesia: "印度尼西亚",
        India: "印度",
        Ireland: "爱尔兰",
        Iran: "伊朗",
        Iraq: "伊拉克",
        Iceland: "冰岛",
        Israel: "以色列",
        Italy: "意大利",
        Jamaica: "牙买加",
        Jordan: "约旦",
        Japan: "日本",
        Kazakhstan: "哈萨克斯坦",
        Kenya: "肯尼亚",
        Kyrgyzstan: "吉尔吉斯斯坦",
        Cambodia: "柬埔寨",
        Kosovo: "科索沃",
        Kuwait: "科威特",
        Laos: "老挝",
        Lebanon: "黎巴嫩",
        Liberia: "利比里亚",
        Libya: "利比亚",
        "Sri Lanka": "斯里兰卡",
        Lesotho: "莱索托",
        Lithuania: "立陶宛",
        Luxembourg: "卢森堡",
        Latvia: "拉脱维亚",
        Morocco: "摩洛哥",
        Moldova: "摩尔多瓦",
        Madagascar: "马达加斯加",
        Mexico: "墨西哥",
        Macedonia: "马其顿",
        Mali: "马里",
        Myanmar: "缅甸",
        Montenegro: "黑山",
        Mongolia: "蒙古",
        Mozambique: "莫桑比克",
        Mauritania: "毛里塔尼亚",
        Malawi: "马拉维",
        Malaysia: "马来西亚",
        Namibia: "纳米比亚",
        "New Caledonia": "新喀里多尼亚",
        Niger: "尼日尔",
        Nigeria: "尼日利亚",
        Nicaragua: "尼加拉瓜",
        Netherlands: "荷兰",
        Norway: "挪威",
        Nepal: "尼泊尔",
        "New Zealand": "新西兰",
        Oman: "阿曼",
        Pakistan: "巴基斯坦",
        Panama: "巴拿马",
        Peru: "秘鲁",
        Philippines: "菲律宾",
        "Papua New Guinea": "巴布亚新几内亚",
        Poland: "波兰",
        "Puerto Rico": "波多黎各",
        "North Korea": "北朝鲜",
        Portugal: "葡萄牙",
        Paraguay: "巴拉圭",
        Qatar: "卡塔尔",
        Romania: "罗马尼亚",
        Russia: "俄罗斯",
        Rwanda: "卢旺达",
        "Western Sahara": "西撒哈拉",
        "Saudi Arabia": "沙特阿拉伯",
        Sudan: "苏丹",
        "South Sudan": "南苏丹",
        Senegal: "塞内加尔",
        "Solomon Islands": "所罗门群岛",
        "Sierra Leone": "塞拉利昂",
        "El Salvador": "萨尔瓦多",
        Somaliland: "索马里兰",
        Somalia: "索马里",
        "Republic of Serbia": "塞尔维亚",
        Suriname: "苏里南",
        Slovakia: "斯洛伐克",
        Slovenia: "斯洛文尼亚",
        Sweden: "瑞典",
        Swaziland: "斯威士兰",
        Syria: "叙利亚",
        Chad: "乍得",
        Togo: "多哥",
        Thailand: "泰国",
        Tajikistan: "塔吉克斯坦",
        Turkmenistan: "土库曼斯坦",
        "East Timor": "东帝汶",
        "Trinidad and Tobago": "特里尼达和多巴哥",
        Tunisia: "突尼斯",
        Turkey: "土耳其",
        "United Republic of Tanzania": "坦桑尼亚",
        Uganda: "乌干达",
        Ukraine: "乌克兰",
        Uruguay: "乌拉圭",
        "United States": "美国",
        Uzbekistan: "乌兹别克斯坦",
        Venezuela: "委内瑞拉",
        Vietnam: "越南",
        Vanuatu: "瓦努阿图",
        "West Bank": "西岸",
        Yemen: "也门",
        "South Africa": "南非",
        Zambia: "赞比亚",
        Korea: "韩国",
        Tanzania: "坦桑尼亚",
        Zimbabwe: "津巴布韦",
        Congo: "刚果",
        "Central African Rep.": "中非",
        Serbia: "塞尔维亚",
        "Bosnia and Herz.": "波黑",
        "Czech Rep.": "捷克",
        "W. Sahara": "西撒哈拉",
        "Lao PDR": "老挝",
        "Dem.Rep.Korea": "朝鲜",
        "Falkland Is.": "福克兰群岛",
        "Timor-Leste": "东帝汶",
        "Solomon Is.": "所罗门群岛",
        Palestine: "巴勒斯坦",
        "N. Cyprus": "北塞浦路斯",
        Aland: "奥兰群岛",
        "Fr. S. Antarctic Lands": "法属南半球和南极陆地",
        Mauritius: "毛里求斯",
        Comoros: "科摩罗",
        "Eq. Guinea": "赤道几内亚",
        "Guinea-Bissau": "几内亚比绍",
        "Dominican Rep.": "多米尼加",
        "Saint Lucia": "圣卢西亚",
        Dominica: "多米尼克",
        "Antigua and Barb.": "安提瓜和巴布达",
        "U.S. Virgin Is.": "美国原始岛屿",
        Montserrat: "蒙塞拉特",
        Grenada: "格林纳达",
        Barbados: "巴巴多斯",
        Samoa: "萨摩亚",
        Bahamas: "巴哈马",
        "Cayman Is.": "开曼群岛",
        "Faeroe Is.": "法罗群岛",
        "IsIe of Man": "马恩岛",
        Malta: "马耳他共和国",
        Jersey: "泽西",
        "Cape Verde": "佛得角共和国",
        "Turks and Caicos Is.": "特克斯和凯科斯群岛",
        "St. Vin. and Gren.": "圣文森特和格林纳丁斯"
      };
      words.resize();
      api.getPicDataByNames("loading_destination", year, iore).then(res => {
        var data = res.data.DATA;
        var GeoCoordMap = {};
        res.data.GIS.forEach((v, i) => {
          GeoCoordMap[v.name] = v.gis;
        });
        var Datas = this.arrTrans(1, res.data.DATA);

        var convertData = function(data) {
          var res = [];
          for (var i = 0; i < data.length; i++) {
            var dataItem = data[i];
            // 			console.log('dataItem',dataItem) //第二个数据
            var a1 = GeoCoordMap["中国"].split(",")[0];
            var a2 = GeoCoordMap["中国"].split(",")[1];
            var arr1 = [
              Number(a1.substr(1)),
              Number(a2 ? a2.substr(0, a2.length - 1) : "")
            ];
            var fromCoord = arr1;
            // console.log(fromCoord)
            var toCoord = GeoCoordMap[dataItem[0].name];
            var a3 = GeoCoordMap[dataItem[0].name].split(",")[0];
            var a4 = GeoCoordMap[dataItem[0].name].split(",")[1];
            var arr2 = [
              Number(a3.substr(1)),
              Number(a4 ? a4.substr(0, a4.length - 1) : "")
            ];
            var toCoord = arr2;
            if (fromCoord && toCoord) {
              if (iore == "出口") {
                res.push([
                  {
                    coord: fromCoord,
                    value: dataItem[0].value
                  },
                  {
                    coord: toCoord,
                    dataItem: dataItem
                  }
                ]);
              } else if (iore == "进口") {
                res.push([
                  {
                    coord: toCoord,
                    dataItem: dataItem
                  },
                  {
                    coord: fromCoord,
                    value: dataItem[0].value
                  }
                ]);
              }
            }
          }
          return res;
        };
        var series = [];
        [["中国", Datas]].forEach(function(item, i) {
          series.push(
            {
              type: "lines",
              zlevel: 0,
              effect: {
                // 括 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
                show: true,
                period: 4, //箭头指向速度，值越小速度越快
                trailLength: 0.1, //特效尾迹长度[0,1]值越大，尾迹越长重
                symbol: "arrow", //箭头图标
                symbolSize: 3, //图标大小
                color: "#fff"
              },
              lineStyle: {
                normal: {
                  width: 0.7, //尾迹线条宽度
                  opacity: 1, //尾迹线条透明度
                  curveness: 0.2, //尾迹线条曲直度
                  color: function(params) {
                    //圆环显示文字
                    return "#359fd1";
                  }
                },
                color: "red"
              },
              data: convertData(item[1])
            },
            {
              type: "effectScatter",
              coordinateSystem: "geo",
              zlevel: 3,
              rippleEffect: {
                //涟漪特效
                period: 4, //动画时间，值越小速度越快
                brushType: "stroke", //波纹绘制方式 stroke, fill
                scale: 4.2 //波纹圆环最大限制，值越大波纹越大
              },
              // 括 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
              // symbol: 'none',
              symbol: "circle",
              symbolSize: function(val) {
                return 5; //圆环大小
              },

              itemStyle: {
                normal: {
                  show: false,
                  color: "#fff",
                  borderWidth: 0,
                  shadowColor: "#fff", //发光🉐效果
                  shadowBlur: 4
                }
              },
              data: item[1].map(function(dataItem) {
                var a1 = GeoCoordMap[dataItem[0].name].split(",")[0];
                var a2 = GeoCoordMap[dataItem[0].name].split(",")[1];
                var arr = [
                  Number(a1.substr(1)),
                  Number(a2 ? a2.substr(0, a2.length - 1) : "")
                ];
                return {
                  dataItem: dataItem,
                  name: dataItem[0].name,
                  value: arr
                };
              })
            }
          );
        });

        var option = {
          type: "map",
          mapType: "world",
          tooltip: {
            formatter: function(e) {
              if (iore == "出口") {
                return (
                  "中国 -> " +
                  e.data.dataItem[0].name +
                  "    " +
                  e.data.dataItem[0].value
                );
              } else if (iore == "进口") {
                return (
                  e.data.dataItem[0].name +
                  " -> 中国" +
                  "    " +
                  e.data.dataItem[0].value
                );
              }
            }
          },
          geo: {
            map: "world",
            zoom: 1.2,
            label: {
              emphasis: {
                show: true,
                color: "white"
              }
            },
            // roam: true, //是否允许缩放
            itemStyle: {
              normal: {
                color: "#68d9fb", //地图背景色
                borderColor: "#68d9fb", //省市边界线00fcff 516a89
                borderWidth: 1
              },
              emphasis: {
                color: "#45A5F8" //悬浮背景
              }
            }
          },
          nameMap: nameMap,
          series: series
        };
        words.setOption(option);
      });
    },
    time(moveYearsList) {
      this.timeLine = echarts.init(document.getElementById("timeLine"));
      let option = {
        timeline: {
          data: moveYearsList,
          axisType: "category",
          autoPlay: false,
          playInterval: 3000,
          left: "0",
          right: "0",
          bottom: "5%",
          width: "100%",
          //  height: null,
          label: {
            normal: {
              textStyle: {
                color: "#ddd"
              }
            },
            emphasis: {
              textStyle: {
                color: "#fff"
              }
            }
          },
          symbolSize: 10,
          lineStyle: {
            color: "#555"
          },
          checkpointStyle: {
            borderColor: "#777",
            borderWidth: 2
          },
          controlStyle: {
            showNextBtn: true,
            showPrevBtn: true,
            normal: {
              color: "#666",
              borderColor: "#666"
            },
            emphasis: {
              color: "#aaa",
              borderColor: "#aaa"
            }
          }
        }
      };
      this.timeLine.setOption(option);
      this.timeLine.on("timelinechanged", v => {
        let time = moveYearsList[v.currentIndex];
        time = time.substr(0, time.length - 1);
        this.map(time, this.iore); //地图
        // this.thin1(time); //折线图1
        this.tree(time, this.iore); //树图
        this.graph(time, this.iore); //柱图
        this.word(time, this.iore); //世界图
        // this.graph2(time); //柱图
      });
    },
    arrTrans(num, arr) {
      // 一维数组转换为二维数组
      const iconsArr = []; // 声明数组
      arr.forEach((item, index) => {
        const page = Math.floor(index / num); // 计算该元素为第几个素组内
        if (!iconsArr[page]) {
          // 判断是否存在
          iconsArr[page] = [];
        }
        iconsArr[page].push(item);
      });
      return iconsArr;
    },
    changeIore() {
      api.getHaiGuanDimensions().then(res => {
        let year = res.data.time[0].slice(0, 4);
        this.moveYearsList = res.data.time;
        this.map(year, this.iore); //地图
        this.tree(year, this.iore); //树图
        this.graph(year, this.iore); //柱图
        this.word(year, this.iore); //世界图
      });
    }
  },
  mounted() {
    this.changeIore();
  },
  beforeDestroy() {
    if (!this.timeLine) {
      return;
    }
    this.timeLine.dispose();
    this.timeLine = null;
  }
};
</script>
<style scoped lang="less">
/* scrollbar */
.rightChart::-webkit-scrollbar {
  width: 5px;
  height: 10px;
}
.rightChart::-webkit-scrollbar-thumb {
  background: #3583ed;
  border-radius: 5px;
}
.rightChart::-webkit-scrollbar-track {
  background: #dfdfdf;
  border-radius: 5px;
}
/* 针对IE的scrollbar */
.rightChart {
  scrollbar-face-color: #3583ed; /*3D表面（ThreedFace）*/
  scrollbar-highlight-color: #dfdfdf; /*3D界面的亮边（ThreedHighlight）*/
  scrollbar-shadow-color: #dfdfdf; /*3D界面的暗边（ThreedShadow）*/
  scrollbar-3dlight-color: #dfdfdf; /*亮边框*/
  scrollbar-arrow-color: #3583ed; /*方向箭头 */
  scrollbar-track-color: #dfdfdf; /*拖动区域(TrackBar)*/
  scrollbar-darkshadow-color: #dfdfdf; /*暗边框（ThreedDarkShadow）*/
}
/* 针对firefox的scrollbar */
.rightChart {
  scrollbar-color: #3583ed #dfdfdf;
  scrollbar-width: thin;
}
/* Edge 的scrollbar隐藏*/
/* .rightChart{
    -ms-overflow-style:none;
} */
// 可视化
.rightChart {
  width: 97%;
  height: auto;
  margin-right: 20px;
  padding: 80px 20px 50px 20px;
  background: rgba(5, 43, 79, 0.3);
  border: 1px solid #08396a;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  // overflow-x: scroll;
  overflow: auto;
  .radio {
    position: absolute;
    left: 35%;
    top: 40px;
    /deep/ .el-radio__label {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #dfecf7;
    }
  }
  .bottomLeft {
    width: 55%;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-right: 50px;
    //  标题
    .mapTitle {
      width: 100%;
      height: 40px;
      line-height: 40px;
      display: flex;
      border-bottom: 1px solid #08396a;

      .littleImg {
        img {
          width: 12px;
          height: 12px;
        }
      }

      .word {
        margin-left: 4px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #dfecf7;
      }
    }
  }
  .bottomRight {
    width: 40%;
    height: auto;
    display: flex;
    flex-direction: column;
    //  标题
    .cakeTitle {
      width: 100%;
      height: 40px;
      line-height: 40px;
      display: flex;
      border-bottom: 1px solid #08396a;
      .littleImg {
        img {
          width: 12px;
          height: 12px;
        }
      }

      .word {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #dfecf7;
        margin-left: 4px;
      }
    }
  }
}
#map,
#word {
  width: 100%;
  height: 603px;
  margin: 0 auto;
  overflow: hidden;
}
#tree,
#graph {
  width: 100%;
  height: 603px;
  margin: 0 auto;
  overflow: hidden;
}
.bottom_timeLine {
  width: 100%;
  height: 100px;
  margin-top: 20px;
  #timeLine {
    width: 100%;
    height: 100px;
    margin: 0 auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/chart.vue